import React from 'react';
import { DatePicker, Menu, Row, Col, Dropdown, Button } from 'antd';
import moment from 'moment';
import { DownOutlined, CalendarOutlined } from '@ant-design/icons';
import { ranges } from '../../core/hooks/ByDateFilter';
const { RangePicker } = DatePicker;

const DatePickerField = ({
  defaultPickerValue,
  defaultValue,
  value,
  onChange,
  data,
  dropDownValue,
  setDropDownValue,
  setCustomDateRange,
  has6MonDisables = true,
  screens,
}) => {
  /**
   * 6 months lookback only
   */
  const disabledDates = (current) => {
    //Alwats disable dates that is beyond default range
    if (current >= defaultValue[1] || current <= defaultPickerValue[0]) {
      return true;
    }
    if (has6MonDisables) {
      if (current <= moment().subtract(6, 'months')) {
        return true;
      } else if (current >= moment()) {
        return true;
      } else {
        return false;
      }
    }
  };

  // sort them by desc dates

  const onHandleDropdown = (e) => {
    setDropDownValue(e.key);
    handleOnChange(ranges[e.key]);
  };

  const menuItems = Object.entries(ranges).map((r) => (
    <Menu.Item key={r[0]} icon={<CalendarOutlined />}>
      {r[0]}
    </Menu.Item>
  ));

  const handleOnChange = (v) => {
    const getSelectedStartDate = moment(v[0] || value[0]).unix();
    const getSelectedEndDate = moment(v[1] || value[1]).unix();

    //make sure to only have valid date ranges
    if (getSelectedStartDate <= getSelectedEndDate && getSelectedEndDate >= getSelectedStartDate) {
      // filter data to get only between range dates
      const getFilteredData = data.filter((obj) => {
        const objDate = obj.date;
        return objDate >= getSelectedStartDate && objDate <= getSelectedEndDate;
      });

      onChange({
        data: getFilteredData,
        dates: v,
      });
    }
  };

  return (
    <>
      <Row>
        <Col span="24">
          <RangePicker
            allowClear={false}
            disabledDate={disabledDates}
            defaultPickerValue={defaultPickerValue}
            defaultValue={defaultValue}
            value={value}
            onChange={handleOnChange}
            style={{
              marginBottom: '0.4rem',
              width: screens && screens.xs === true ? '100%' : '',
              minWidth: '230px',
            }}
            onCalendarChange={(v) => {
              const getSelectedStartDate = moment(v[0] || value[0]).unix();
              const getSelectedEndDate = moment(v[1] || value[1]).unix();
              //make sure to only have valid date ranges
              if (
                getSelectedStartDate <= getSelectedEndDate &&
                getSelectedEndDate >= getSelectedStartDate
              ) {
                setCustomDateRange(v);
                setDropDownValue('Custom');
              }
            }}
          />
          <Dropdown
            overlay={<Menu onClick={onHandleDropdown}>{menuItems}</Menu>}
            style={{ marginBottom: '0.4rem' }}
          >
            <Button
              style={{
                marginBottom: '0.4rem',
                width: screens && screens.xs === true ? '100%' : '',
              }}
            >
              <CalendarOutlined />
              {dropDownValue} <DownOutlined />
            </Button>
          </Dropdown>
        </Col>
      </Row>
    </>
  );
};

export default DatePickerField;
